var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 31,
    viewBox: "0 0 81 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2254_44855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.47144 12.5885L8.07258 8.69026V22.2636H22.594L17.2263 26.8193H6.79945C4.96144 26.8193 3.47144 25.3592 3.47144 23.558V12.5885Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7625 4.55711L7.97644 8.77938H22.5001V22.3495L27.2164 18.2478V7.81846C27.2164 6.01727 25.7284 4.55711 23.893 4.55711H12.7625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05627 8.73125H22.5794V22.2884H8.05627V8.73125Z",
    fill: "#B1FC1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7858 15.6884C34.7858 20.5278 38.4211 23.7 42.89 23.7C45.5759 23.7 47.7293 22.5885 49.2575 20.8982V15.1095H41.9406V17.4945H46.5484V19.9026C45.8538 20.5509 44.4645 21.2919 42.89 21.2919C39.8335 21.2919 37.5644 18.9301 37.5644 15.6884C37.5644 12.4467 39.8335 10.1081 42.89 10.1081C44.6266 10.1081 46.0853 11.0111 46.8958 12.1689L49.1186 10.9185C47.8683 9.13558 45.9001 7.69998 42.89 7.69998C38.4211 7.69998 34.7858 10.849 34.7858 15.6884Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0258 23.399L60.2515 17.3324C62.1039 17.0314 63.91 15.5495 63.91 12.794C63.91 9.946 61.9187 7.95468 58.8623 7.95468H52.0779V23.399H54.787V17.6334H57.473L60.8999 23.399H64.0258ZM61.1314 12.794C61.1314 14.276 60.02 15.2485 58.4918 15.2485H54.787V10.3396H58.4918C60.02 10.3396 61.1314 11.3121 61.1314 12.794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3264 23.399V17.6334H73.4017C76.6202 17.6334 78.4494 15.4105 78.4494 12.794C78.4494 10.1775 76.6434 7.95468 73.4017 7.95468H66.6173V23.399H69.3264ZM75.6709 12.794C75.6709 14.276 74.5594 15.2485 73.0312 15.2485H69.3264V10.3396H73.0312C74.5594 10.3396 75.6709 11.3121 75.6709 12.794Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2254_44855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 29.7143,
    fill: "white",
    transform: "translate(0.5 0.842834)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.a2fd2dfb73035e4f1c6b580f70bec41c.svg";
export { ForwardRef as ReactComponent };